import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * A custom schema with enough information to be able to handle a specific
 * resource type.
 */
export var RID = /*#__PURE__*/function () {
  /**
   * Create a new resource id from scratch, given an entity type and id. To parse an existing resource id, see `RID.parse`
   */
  function RID(entityType, entityId) {
    var parentResourceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RID.Protocol;
    _classCallCheck(this, RID);
    this.entityType = entityType;
    this.entityId = entityId;
    this.parentResourceId = parentResourceId;
  }
  return _createClass(RID, [{
    key: "toString",
    value: function toString() {
      var firstSeparator = this.parentResourceId === RID.Protocol ? '' : '/';
      var url = new URL("".concat(this.parentResourceId).concat(firstSeparator).concat(this.entityType, "-").concat(this.entityId));
      return url.toString();
    }
  }, {
    key: "parent",
    value: function parent() {
      if (this.parentResourceId === RID.Protocol) {
        return undefined;
      }
      return RID.parse(this.parentResourceId);
    }
  }, {
    key: "createChild",
    value: function createChild(resourceEntityType, resourceEntityId) {
      return new RID(resourceEntityType, resourceEntityId, this.toString());
    }
  }, {
    key: "findEntityType",
    value: function findEntityType(resourceEntityType) {
      if (this.entityType === resourceEntityType) {
        return this;
      }
      var currentUri = this.parent();
      while (currentUri) {
        var _currentUri;
        if (((_currentUri = currentUri) === null || _currentUri === void 0 ? void 0 : _currentUri.entityType) === resourceEntityType) {
          break;
        }
        currentUri = currentUri.parent();
      }
      return currentUri;
    }
  }], [{
    key: "parse",
    value: function parse(input) {
      var _targetSegment$match;
      var url = new URL(input);
      if (url.protocol !== RID.Protocol) {
        return new RID('', '');
      }
      var uriSegments = url.pathname.split('/');
      var _uriSegments$slice = uriSegments.slice(-1),
        _uriSegments$slice2 = _slicedToArray(_uriSegments$slice, 1),
        targetSegment = _uriSegments$slice2[0];
      var resourceSegments = uriSegments.slice(0, -1);
      var _ref = (_targetSegment$match = targetSegment.match(/^([A-z0-9\.\_]*)-([A-z0-9\-\_\=]*)$/)) !== null && _targetSegment$match !== void 0 ? _targetSegment$match : [],
        _ref2 = _slicedToArray(_ref, 3),
        entityType = _ref2[1],
        entityId = _ref2[2];
      return new RID(entityType, entityId, RID.Protocol + resourceSegments.join('/'));
    }
  }]);
}();
_defineProperty(RID, "Protocol", 'sharefile:');